import type { CSSProperties, MouseEventHandler } from 'react';
import { ui } from './theme';

interface Props {
  onClick: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  title?: string;
}

const baseStyle: CSSProperties = {
  ...ui.secondaryBtn,
  width: 36,
  height: 30,
  fontSize: 14,
  fontWeight: 700,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  flexShrink: 0,
};

export function CloseButton({ onClick, style, title = 'Đóng' }: Props) {
  return (
    <button
      type="button"
      aria-label="close"
      title={title}
      style={{ ...baseStyle, ...style }}
      onClick={onClick}
    >
      X
    </button>
  );
}
